<template>
    <v-card class="welcome-card overflow-hidden" :height="height">
        <v-card-text>
            <p class="card-title">
                <KpIcon icon-cls="confetti" color="black" /> {{ $t('welcome') }}, {{ user.firstname }}
                {{ user.lastname }}
            </p>
            <p v-html="$t('welcome_text')"></p>
            <p>
                <v-btn depressed small color="white primary--text" :to="{ name: 'event-edit', params: { id: 'new' } }">
                    <KpIcon icon-cls="new" color="primary" disabled-color="grey" left />
                    {{ $t('neu_event') }}
                </v-btn>
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
import { User } from '@/models/User';
import dayjs from 'dayjs';

export default {
    name: 'WelcomeCard',
    props: {
        user: {
            type: User,
            required: true,
        },
        height: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            today: dayjs(),
        };
    },
};
</script>

<style lang="scss" scoped>
.welcome-card {
    p {
        max-width: 350px;
        font-size: 1rem;
        color: var(--gray-text-color);
        &.card-title {
            color: var(--nearblack-color);
        }
    }
    background-image: url('~@/assets/minasa-dashboard-box-2.1.png');
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: cover;
}
</style>
